export { CONSENT_COOKIE_NAME, CONSENT_POLICY_VERSION } from './policy-version'

/** 180 days, the usual re-consent horizon. */
export const CONSENT_COOKIE_MAX_AGE_SEC = 180 * 24 * 60 * 60
